import { FaWhatsapp } from "react-icons/fa";
import { getWhatsappUrl } from "@/config/site";

export default function WhatsAppButton() {
  return (
    <a
      href={getWhatsappUrl()}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 right-5 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full  bg-green-500 text-[#f2e6c9] shadow-[0_14px_35px_rgba(26,26,26,0.28)] transition-[transform,background-color] duration-300 hover:scale-105"
      aria-label="Contact on WhatsApp"
      data-testid="floating-whatsapp-button"
    >
      <FaWhatsapp className="h-6 bg-green-500 w-6" />
    </a>
  );
}
